module.exports = __webpack_public_path__ + "img/log.bbd14d73.svg";